<!-- Template -->
<div
  [ngClass]="{'cargo__options--ellipsis':type === 'ellipsis', 'cargo__options--button':type === 'button', 'cargo__options--text':type === 'text'}">
  <!-- ellipsis -->
  <i class="fas fa-ellipsis-v color-secondary-dark text-strong" mat-icon-button [matMenuTriggerFor]="menuOptionsCargo"
    *ngIf="type === 'ellipsis'"></i>
  <!-- button -->
  <button mat-raised-button [matMenuTriggerFor]="menuOptionsCargo" class="primary-secondary cargo__options--button"
    color="primary" *ngIf="type === 'button'">
    Opciones
  </button>
  <!-- Text -->
  <div mat-raised-button [matMenuTriggerFor]="menuOptionsCargo" class="primary-secondary" color="primary"
    *ngIf="type === 'text'">
    Opciones
  </div>
</div>
<!-- Options -->
<mat-menu #menuOptionsCargo="matMenu" class="cargo__options--menu">
  <button mat-menu-item (click)="openDetailCargo()"
    *ngIf="cargo && (cargo.state === cargoStateEnum.START_SERVICE||['ellipsis','text'].includes(type))">
    <i class="fas fa-eye"></i>
    Ver detalles del servicio
  </button>
  <button mat-menu-item (click)="openDialogNewAdvancePercentage()" permission-display [module]="permission.cargo.module"
    [functionality]="permission.cargo.editAdvance"
    *ngIf="!isSatelliteLockService && ![cargoStateEnum.DELETED,cargoStateEnum.EXPIRED,cargoStateEnum.END_SERVICE, cargoStateEnum.REQUEST].includes(cargo?.state) && (!cargo?.shippingCost?.advanceState || !haveAdvancePayments) && !cargo?.shippingCost?.paid">
    <i class="fas fa-edit"></i>
    Editar Anticipo
  </button>
  <button mat-menu-item (click)="openDialogChangeReteica()"
    *ngIf="!isSatelliteLockService && ![cargoStateEnum.DELETED,cargoStateEnum.EXPIRED, cargoStateEnum.REQUEST].includes(cargo?.state) && !this.hasBalanceAndIsPaid"
    permission-display [module]="permission.cargo.module" [functionality]="permission.cargo.changeRteica">
    <i class="fas fa-exchange-alt"></i>
    Modificar reteica
  </button>
  <button mat-menu-item (click)="getTracepoints()" permission-display [module]="permission.cargo.module"
    [functionality]="permission.cargo.showAnomaliesCargo"
    *ngIf="cargo?.state !== cargoStateEnum.EXPIRED && cargo?.lastPointLocation">
    <i class="fas fa-history"></i>
    Historial de novedades
  </button>
  <button mat-menu-item (click)="btnDeleteCarga()" permission-display [module]="permission.cargo.module"
    [functionality]="permission.cargo.removeCargo"
    *ngIf="![cargoStateEnum.DELETED,cargoStateEnum.EXPIRED].includes(cargo?.state)">
    <i class="fas fa-ban"></i>
    Anular Servicio
  </button>
  <div [matTooltip]="showBtnApproveCargo.errorMessage" matTooltipClass="tooltip__error" matTooltipPosition="left"
    *ngIf="showBtnApproveCargo.isSelectable">
    <button mat-menu-item (click)="openDialogApproveCargo(true)" [disabled]="!showBtnApproveCargo.isEnabled">
      <i class="fas fa-thumbs-up"></i>
      Aprobar servicio
    </button>
  </div>

  <div [matTooltip]="showBtnDisapproveCargo.errorMessage" matTooltipClass="tooltip__error" matTooltipPosition="left"
    *ngIf="showBtnDisapproveCargo.isSelectable">
    <button mat-menu-item (click)="openDialogApproveCargo(false)" [disabled]="!showBtnDisapproveCargo.isEnabled">
      <i class="fas fa-thumbs-down"></i>
      No aprobar servicio
    </button>
  </div>

  <button mat-menu-item (click)="openModalReturnApproveCargo()"
    *ngIf="(cargo?.approval === 'Approved' || cargo?.approval ==='Rejected') && cargo.state == cargoStateEnum.END_SERVICE && !this.hasBalanceAndIsPaid"
    permission-display [module]="permission.payments.module" [functionality]="permission.payments.reverseApproval">
    <i class="fas fa-undo"></i>
    Reversar <span *ngIf="cargo?.approval ==='Rejected'">No</span> aprobación
  </button>
  <button mat-menu-item *ngIf="showOptionEditAndDisassociate" (click)="editBill()" permission-display
    [module]="permission.payments.module" [functionality]="permission.payments.charges">
    <i class="fas fa-file-invoice"></i>
    Modificar Factura
  </button>
  <button mat-menu-item *ngIf="showOptionEditAndDisassociate" (click)="disassociateBill()" permission-display
    [module]="permission.payments.module" [functionality]="permission.payments.charges">
    <i class="fas fa-file-invoice"></i>
    Desasociar Factura
  </button>
  <button mat-menu-item *ngIf="cargo?.shippingCost?.cashed && cargo?.shippingCost?.checked" permission-display
    [module]="permission.payments.module" [functionality]="permission.payments.charges" (click)="editIncome()">
    <i class="fas fa-file-invoice"></i>
    Modificar Comprobante
  </button>
  <button mat-menu-item *ngIf="cargo?.shippingCost?.cashed && cargo?.shippingCost?.checked" permission-display
    [module]="permission.payments.module" [functionality]="permission.payments.charges" (click)="disassociateIncome()">
    <i class="fas fa-file-invoice"></i>
    Desasociar Comprobante
  </button>
  <div [matTooltip]="showFindApplicationsBtn.reason" matTooltipClass="tooltip__error" matTooltipPosition="left"
    *ngIf="showFindApplicationsBtn.show">
    <button mat-menu-item class="has-applications-badge" (click)="findApplications()"
      [disabled]="!showFindApplicationsBtn.can">
      <i class="fas fa-search"></i>
      Buscar postulaciones
      <div class="container-number" *ngIf="visualNumberOfOffers">
        {{visualNumberOfOffers}}
      </div>
    </button>
  </div>
  <div [matTooltip]="showAssignVehicleBtn.reason" matTooltipClass="tooltip__error" matTooltipPosition="left"
    *ngIf="showAssignVehicleBtn.show">
    <button mat-menu-item (click)="openModalAssignVehicle()" [disabled]="!showAssignVehicleBtn.can">
      <i class="fas fa-bus"></i>
      Asignar {{isEscortedService? 'escolta' : 'vehículo'}}
    </button>
  </div>
  <button mat-menu-item (click)="showAssignedVehicleData()" *ngIf="authService.getCompany()?.companyId === environment.rootNit && ![cargoStateEnum.DELETED,cargoStateEnum.EXPIRED,cargoStateEnum.END_SERVICE].includes(cargo?.state) 
    && cargo?.confirmedDriver && !isNegotiation && cargo?.licensePlate && (isEscortedService||isTransportService)">
    <i class="fas fa-bus"></i>
    {{isEscortedService? 'Escolta' : 'Vehículo'}} Asignado {{cargo.licensePlate}}
  </button>
  <button mat-menu-item (click)="checkConfirmStartService()" *ngIf="showStartServiceBtn">
    <i class="fas fa-play-circle"></i>
    Iniciar servicio
  </button>
  <button mat-menu-item (click)="openDialogSatelliteLock()"
    *ngIf="isSatelliteLockService && !isNegotiation && [cargoStateEnum.ACCEPTED, cargoStateEnum.CREATED].includes(cargo?.state) && !cargo?.confirmedDriver && permissionRole.hasPermission(permission.cargo.module, permission.cargo.assignSatelliteLock)">
    <i class="fas fa-lock"></i>
    {{cargo?.lock?.imei ? 'Reasignar' : 'Asignar'}} candado satelital
  </button>

  <div [matTooltip]="showBtnModificationsShippingCost.error" matTooltipClass="tooltip__error" matTooltipPosition="left"
    *ngIf="showBtnModificationsShippingCost.show">
    <button mat-menu-item (click)="openDiscountsAndBonuses()" [disabled]="!showBtnModificationsShippingCost.canModify">
      <i class="fas fa-edit" *ngIf="showBtnModificationsShippingCost.canModify"></i>
      <i class="fas fa-exclamation-triangle" [ngStyle]="{'color': 'red'}"
        *ngIf="!showBtnModificationsShippingCost.canModify"></i>
      Bonificaciones y descuentos
    </button>
  </div>
  <button mat-menu-item (click)="openLoadExternalManifest()" permission-display [module]="permission.cargo.module"
    [functionality]="permission.cargo.uploadExternalManifest"
    [matTooltip]="documentRecreationInProgress ? documentRecreationInProgressMessage : ''"
    *ngIf="!isNegotiation && !cargo?.ministry && isTransportService && !cargo?.manifest 
    && !['Urbana','Última milla'].includes(cargo?.cargoModel?.tripType?.name) 
    && ![cargoStateEnum.DELETED,cargoStateEnum.EXPIRED,cargoStateEnum.REQUEST,cargoStateEnum.END_SERVICE].includes(cargo?.state)">
    <i class="fas fa-upload"></i>
    Cargar Manifiesto Externo
  </button>
  <button mat-menu-item (click)="openExternalManifest()" permission-display [module]="permission.cargo.module"
    [functionality]="permission.cargo.readManifest"
    *ngIf="!isNegotiation && cargo?.externalManifest && isTransportService">
    <i class="fas fa-file-alt"></i>
    Ver Manifiesto Externo
  </button>
  <button mat-menu-item (click)="openCargoPDF(PDFTypes.ORDER_VEHICLE)" *ngIf="![cargoStateEnum.DELETED,cargoStateEnum.EXPIRED,cargoStateEnum.REQUEST].includes(cargo?.state) &&
    !isNegotiation && cargo?.driver && hasOrderVehiclePermission && (isEscortedService||isTransportService)">
    <i class="fas fa-file-alt"></i>
    Orden de {{isEscortedService? 'servicio' : 'cargue'}}
  </button>
  <app-generate-manifest-action *ngIf="cargo?.ministry && ((!cargo?.manifestAuthorization && !rndcContingencyActive) || (rndcContingencyActive && !cargo?.manifest)) &&
  [cargoStateEnum.ACCEPTED, cargoStateEnum.START_SERVICE, cargoStateEnum.END_SERVICE].includes(cargo?.state)"
    [cargo]="cargo" type="cargo-option" (refreshLoad)="refreshCargo.emit($event)"></app-generate-manifest-action>
  <!-- <div matTooltip="{{ cannotShowManifestReason }}" matTooltipPosition="above" *ngIf="cargo && cargo.cargoModel && cargo.cargoModel.tripType && cargo.cargoModel.tripType.name && (cargo.cargoModel.tripType.name !== 'Urbana' || cargo.cargoModel.tripType.name !== 'Última milla')"> -->
  <div matTooltip="{{ cannotShowManifestReason }}" matTooltipPosition="above"
    *ngIf="cargo?.ministry && hasManifestPermission && ![cargoStateEnum.REQUEST,cargoStateEnum.EXPIRED].includes(cargo?.state)">
    <button mat-menu-item (click)="openCargoPDF(PDFTypes.MANIFEST)" permission-display
      [module]="permission.cargo.module" [functionality]="permission.cargo.readManifest"
      [disabled]="disableViewManifest" *ngIf="cargo && !isNegotiation">
      <i class="fas fa-file-alt"></i>
      Manifiesto
    </button>
  </div>
  <span [matTooltip]="documentRecreationInProgress ? documentRecreationInProgressMessage :
      rndcContingencyActive && cargo && !cargo.manifestAuthorization ? rndcCancelManifestBlockedTooltip : ''"
    matTooltipPosition="above" class="d-block" *ngIf="showCancelManifestOption">
    <button mat-menu-item [disabled]="documentRecreationInProgress ||
      (rndcContingencyActive && cargo && !cargo.manifestAuthorization)" (click)="openCancelManifest()">
      <i class="fas fa-file-excel"></i>
      Anular Manifiesto
    </button>
  </span>

  <div *ngIf="canAccessConsignments.show" [matTooltip]="canAccessConsignments.reason" matTooltipPosition="above">
    <button mat-menu-item (click)="openCargoPDF(PDFTypes.CONSIGNMENT)" [disabled]="!canAccessConsignments.canAccess">
      <i class="fas fa-file-alt"></i>
      {{consignmentAssociated > 1 ? 'Remesas' : 'Remesa'}}
    </button>
  </div>

  <div *ngIf="canCancelConsignment.show" [matTooltip]="canCancelConsignment.reason" matTooltipPosition="above">
    <button mat-menu-item (click)="cancelConsignment()" [disabled]="!canCancelConsignment.canCancel">
      <i class="fas fa-trash"></i>
      Anular {{consignmentAssociated > 1 ? 'remesas' : 'remesa'}}
    </button>
  </div>
  <!-- Urban -->
  <button mat-menu-item (click)="openCargoPDF(PDFTypes.MANIFEST_URBAN)" permission-display
    [module]="permission.cargo.module" [functionality]="permission.cargo.readManifest"
    *ngIf="!cargo?.ministry && cargo?.licensePlate && cargo?.driver && hasManifestUrbanPermission && isTransportService">
    <i class="fas fa-file-alt"></i>
    Planilla urbana
  </button>
  <!-- Urban -->
  <div *ngIf="!cargo?.ministry && hasConsignmentUrbanPermission && isTransportService"
    matTooltip="{{ !cargo?.licensePlate ? 'Para visualizar la guía terrestre, se debe asociar una placa al servicio' : '' }}"
    matTooltipPosition="above">
    <button mat-menu-item (click)="openCargoPDF(PDFTypes.CONSIGNMENT_URBAN)" [disabled]="!cargo?.licensePlate">
      <i class="fas fa-file-alt"></i>
      Guía terrestre
    </button>
  </div>

  <div
    matTooltip="{{ isUrbanService ? 'No se puede asociar un plan de ruta a un servicio urbano' : !cargo?.routePlanId || !cargo?.itineraryId ? 'No se ha asociado un plan de ruta' : !cargo?.licensePlate ? 'Para visualizar el plan de ruta, se debe asociar una placa al servicio' : '' }}"
    matTooltipPosition="above" *ngIf="hasPlanningRoutePermission &&
    ![cargoStateEnum.DELETED,cargoStateEnum.EXPIRED,cargoStateEnum.REQUEST].includes(cargo?.state)">
    <button mat-menu-item (click)="openCargoPDF(PDFTypes.PLANNING_ROUTE)"
      [disabled]="isUrbanService || !cargo?.routePlanId || !cargo?.itineraryId || !cargo?.licensePlate">
      <i class="fas fa-file-alt"></i>
      Plan de ruta
    </button>
  </div>
  <button mat-menu-item (click)="openHistoryPayments()" *ngIf="cargo?.shippingCost?.payments?.length" permission-display
    [module]="permission.cargo.module" [functionality]="permission.cargo.showPaymentCargo">
    <i class="fas fa-dollar-sign"></i>
    Historial de pagos
  </button>
  <button mat-menu-item (click)="openModalConfirmDriver()" *ngIf="showConfirmLicensePlateBtn">
    <i class="fas fa-check-circle"></i>
    Confirmar {{isEscortedService? 'escolta' : isSatelliteLockService? 'candado satelital' : 'placa'}}
  </button>
  <button mat-menu-item (click)="disassociateVehicle()" *ngIf="showDisassociateVehicleBtn"
    permission-display [module]="permission.cargo.module" [functionality]="permission.cargo.cancelCargo">
    <i class="fas fa-unlink"></i>
    Desasociar vehículo
  </button>
  <div *ngIf="canAssignSecondDriver.show" [matTooltip]="canAssignSecondDriver.reason" matTooltipPosition="above">
    <button mat-menu-item (click)="openModalAssignSecondDriver()" [disabled]="!canAssignSecondDriver.canAssign">
      <i class="fas fa-user-plus"></i>
      Añadir segundo conductor
    </button>
  </div>
  <div [matTooltip]="canAddTrackingReports.reason" matTooltipPosition="above">
    <button mat-menu-item (click)="openCargoLocationReport()" *ngIf="cargo?.state === cargoStateEnum.START_SERVICE"
      permission-display [module]="permission.cargo.module" [functionality]="permission.cargo.registerLocation"
      [disabled]="!canAddTrackingReports.canAdd">
      <i class="fas fa-map-marker-alt"></i>
      Añadir Seguimiento
    </button>
  </div>
  <!--<button mat-menu-item (click)="executeParentMethod.emit('openPopupContact')"
    *ngIf="cargo?.state === cargoStateEnum.START_SERVICE && !typeList">
    <i class="fas fa-paper-plane"></i>
    Contactar Soporte
  </button>-->
  <button mat-menu-item (click)="openRenewDate()" *ngIf="showRestoreCargo" permission-display
    [module]="permission.cargo.module" [functionality]="permission.cargo.restoreCargo">
    <i class="fas fa-plus-square"></i>
    Restaurar servicio
  </button>
  <button mat-menu-item (click)="openDialogRestartCargo(cargo.consecutive, cargo.id)"
    *ngIf="cargo?.state === cargoStateEnum.END_SERVICE" permission-display [module]="permission.cargo.module"
    [functionality]="permission.cargo.restartCargo">
    <i class="fas fa-undo"></i>
    Retornar a servicios en ruta
  </button>
  <!--button mat-menu-item *ngIf="showCreateRoundedCargo" (click)="openRoundedCargo()" permission-display
    [module]="permission.cargo.module" [functionality]="permission.cargo.createRoundedCargo">
    <i class="fas fa-truck"></i>
    Crear servicio redondo
  </button-->
  <div [matTooltip]="showBtnChangeCompany.error" permission-display [module]="permission.cargo.module"
    [functionality]="permission.cargo.changeCompany" matTooltipClass="tooltip__error" matTooltipPosition="left"
    *ngIf="showBtnChangeCompany.show">
    <button type="button" mat-menu-item (click)="openChangeCompany()" [disabled]="showBtnChangeCompany.disabled">
      <i class="fas fa-building"></i>
      Cambiar compañia asociada
    </button>
  </div>
  <button mat-menu-item (click)="openDialogApprovePayBalance()" permission-display [module]="permission.cargo.module"
    [functionality]="permission.cargo.approveBalanceDriver"
    *ngIf="cargo?.state === cargoStateEnum.END_SERVICE && !hasBalanceAndIsPaid && (isEscortedService||isTransportService) && !cargo?.unlegalizedTravelExpense">
    <i class=" fas fa-thumbs-up"></i>
    Aprobar Pago Saldo
  </button>
  <button mat-menu-item
    (click)="openDialogFastPayment(cargo.id, cargo.consecutive,true, cargo.cargoModel.tripType.name)" permission-display
    [module]="permission.payments.module" [functionality]="permission.payments.fastPaymentRequest"
    *ngIf="canRequestFastPayment">
    <i class="fas fa-money-bill"></i>
    Solicitud de pronto pago
  </button>
  <!-- <button mat-menu-item (click)="openDialogFastPayment(cargo.id, cargo.consecutive, false, cargo.cargoModel.tripType.name)" permission-display [module]="permission.payments.module"
    [functionality]="permission.payments.fastPaymentRequest" *ngIf="cargo && cargo.state === cargoStateEnum.END_SERVICE && cargo.fastPayment">
    <i class="fas fa-money-bill"></i>
    Cancelar solicitud de pronto pago
  </button> -->
  <button mat-menu-item (click)="canOpenRequestAdvance('RequestAdvance')"
    *ngIf="!showCancelAdvance && !cargo?.shippingCost?.advanceState && !hasBalanceAndIsPaid && cargo?.confirmedDriver
    && [cargoStateEnum.START_SERVICE, cargoStateEnum.ACCEPTED].includes(cargo?.state) && (isEscortedService||isTransportService)" permission-display [module]="permission.cargo.module"
    [functionality]="permission.cargo.advanceRequest">
    <i class="fas fa-file-invoice"></i>
    Solicitar pago de anticipo
  </button>

  <button mat-menu-item *ngIf="showCancelAdvance && !cargo?.shippingCost?.advanceState && (isEscortedService||isTransportService) &&
    ![cargoStateEnum.DELETED,cargoStateEnum.EXPIRED,cargoStateEnum.REQUEST].includes(cargo?.state)" permission-display
    (click)="canOpenRequestAdvance('CancelRequest')" [module]="permission.cargo.module"
    [functionality]="permission.cargo.advanceRequest">
    <i class="fas fa-file-invoice"></i>
    Cancelar solicitud de pago de anticipo
  </button>

  <button mat-menu-item (click)="downloadReport()" permission-display [module]="permission.cargo.module"
    [functionality]="permission.cargo.reportAnomalies"
    *ngIf="[cargoStateEnum.START_SERVICE,cargoStateEnum.END_SERVICE].includes(cargo?.state)">
    <i class="fas fa-file-download"></i>
    Reporte Novedades
  </button>

  <button mat-menu-item (click)="openMoveAdvance()" permission-display [module]="permission.cargo.module"
    [functionality]="permission.cargo.moveAdvance"
    *ngIf="![cargoStateEnum.DELETED,cargoStateEnum.EXPIRED,cargoStateEnum.REQUEST].includes(cargo?.state) && (isEscortedService||isTransportService)">
    <i class="fas fa-arrow-right"></i>
    Trasladar anticipos
  </button>

  <button type="button" mat-menu-item (click)="openDuplicateTransportRequest()" permission-display
    [module]="permission.cargo.module" [functionality]="permission.cargo.duplicateTransportRequest">
    <i class="fas fa-clone"></i>
    Duplicar Servicio
  </button>

  <div [matTooltip]="showBtnLinkServices.error" permission-display [module]="permission.cargo.module"
    [functionality]="permission.cargo.linkServices" matTooltipClass="tooltip__error" matTooltipPosition="left"
    *ngIf="showBtnLinkServices.show">
    <button type="button" mat-menu-item (click)="openLinkServices()" [disabled]="showBtnLinkServices.disabled">
      <i class="fas fa-link"></i>
      Crear servicio consolidado
    </button>
  </div>
  <div [matTooltip]="showBtnUnlinkServices.error" permission-display [module]="permission.cargo.module"
    [functionality]="permission.cargo.unlinkServices" matTooltipClass="tooltip__error" matTooltipPosition="left"
    *ngIf="showBtnUnlinkServices.show">
    <button type="button" mat-menu-item (click)="openUnlinkServices()" [disabled]="showBtnUnlinkServices.disabled">
      <i class="fas fa-unlink"></i>
      Desasociar servicio consolidado
    </button>
  </div>
  <div [matTooltip]="showBtnReplicateService.error" permission-display [module]="permission.cargo.module"
    [functionality]="permission.cargo.replicateChanges" matTooltipClass="tooltip__error" matTooltipPosition="left"
    *ngIf="showBtnReplicateService.show">
    <button type="button" mat-menu-item (click)="openReplicateService()" [disabled]="showBtnReplicateService.disabled">
      <i class="fas fa-copy"></i>
      Replicar cambios
    </button>
  </div>
  <div [matTooltip]="canOpenLogisticTimes.reason" matTooltipPosition="left" *ngIf="canOpenLogisticTimes.canView"
    permission-display [module]="permission.cargo.module" [functionality]="permission.cargo.viewLogisticTimes">
    <button type="button" mat-menu-item (click)="openLogisticTimes()" [disabled]="!canOpenLogisticTimes.canOpen">
      <i class="fas fa-clock"></i>
      Registro de monitoreo de manifiesto
    </button>
  </div>
</mat-menu>
<app-assign-vehicle-cargo hidden [cargo]="cargo"></app-assign-vehicle-cargo>